import React from 'react';

import CardContent from '../Card/CardContent';
import CardMain from '../Card/CardMain';
import CardMainHeader from '../Card/CardMainHeader';

const ErrorCard = () => (
  <CardMain>
    <CardContent>
      <CardMainHeader title="Er ging iets mis" />
    </CardContent>
  </CardMain>
);

export default ErrorCard;
